import PlusIcon from "assets/icons/PlusIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import PageHeader from "components/Shared/PageHeader";
import { useNavigate } from "react-router-dom";

type PropType = {
  title?: string;
  subTitle?: React.ReactNode;
  showButton?: boolean;
};
export default function Header({ title, subTitle, showButton = true }: PropType) {
  const navigate = useNavigate();
  return (
    <PageHeader
      heading={title ?? "کارت اقساط"}
      subHeadingComponent={subTitle}
      actionSection={
        showButton && (
          <div>
            <BasicButton
              variant="contained"
              onClick={() => {
                navigate("/installments/add");
              }}
            >
              <PlusIcon scale={0.8} color="#fff" />
              <span>اقساط جدید</span>
            </BasicButton>
          </div>
        )
      }
    />
  );
}
